// Events
import { MODAL_TOGGLE, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

import { getCart } from 'utils/cart';
// Utils
import choozy from 'utils/choozy';

export default component(async (node, ctx) => {
  const { variantSelect } = choozy(node);

  const selects = [].concat(variantSelect);

  node.addEventListener('submit', async (e) => {
    e.preventDefault();

    const notSelectedItems = [];
    const data = new FormData();

    selects.forEach((select) => {
      if (select.value === '') {
        notSelectedItems.push([
          select.dataset.optionsModalId,
          select.dataset.optionsModalSection,
          select.dataset.optionsModalBox,
        ]);
      }

      data.append('items[][id]', select.value);
    });

    if (notSelectedItems.length > 0) {
      const [modalId, modalSection, modalBox] = notSelectedItems[0];

      ctx.emit(MODAL_TOGGLE, null, {
        id: modalId,
        props: {
          modalBox,
          modalSection,
        },
      });

      return;
    }

    await fetch(`${node.action}.js`, {
      method: node.method,
      body: data,
    });

    await getCart().then((response) => {
      ctx.emit(THEME_CART_UPDATED, { cart: response });
    });
  });
});
